export default function (value) {
  const result = value.toFixed(2);
  return result;
}
